import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GlobalService } from '../_core/services/global.service';
import { UserService } from '../_core/services/user.service';

import { ISwitchingServiceOrder, ScheduleModel } from './_models/schedule.model';

@Injectable()
export class ScheduleService extends GlobalService {
  public constructor(
    protected _http: HttpClient,
    protected userService: UserService
  ) {
    super(_http);
  }

  public getAssignees(): any {
    const args = {
      entity: 'Schedule',
      queryname: 'getAssignees',
      orderby: 'userName',
    };

    return this.callServicePost('defaultGet', args, {});
  }

  public assignTo(schedules: ScheduleModel[], assignee: string) {
    const promises = [];

    for (let i = 0; i < schedules.length; i++) {
      const args = {
        entity: 'Schedule',
        queryname: 'assignSchedule',
        userUniqueCode: assignee,
        processId: schedules[i].SWProcessID,
      };

      promises.push(this.callServicePost('defaultInsert', args, {}));
    }

    return forkJoin(promises);
  }

  public removeAssign(schedules: ScheduleModel[]) {
    const promises = [];
    for (let i = 0; i < schedules.length; i++) {
      const args = {
        entity: 'Schedule',
        queryname: 'deleteAssignSchedule',
        processId: schedules[i].SWProcessID,
      };

      promises.push(this.callServicePost('defaultDelete', args, {}));
    }

    return forkJoin(promises);
  }

  public getProcessTypes(): any {
    const args = {
      entity: 'Process',
      queryname: 'getProcessTypes',
      orderby: 'processTypeName',
    };

    return this.callServicePost('defaultGet', args, {});
  }

  public getProcessStates(): any {
    const args = {
      entity: 'Process',
      queryname: 'getProcessStates',
      orderby: 'processStateUniqueCode',
    };

    return this.callServicePost('defaultGet', args, {});
  }

  public getInitialData(): any {
    return forkJoin(this.getAssignees(), this.getProcessTypes(), this.getProcessStates());
  }

  /**
   * @param args
   */
  public getScheduleList(args: any): Observable<ISwitchingServiceOrder> {
    const url = `/listeners/ms/workorder/switching-service-order/get`;

    return this._http.post(url, args).pipe(
      map((response: any) => {
        return response.Body.Result;
      })
    );
  }
}
